import { render, staticRenderFns } from "./month.vue?vue&type=template&id=201c1f4c&"
import script from "./month.vue?vue&type=script&lang=ts&setup=true&"
export * from "./month.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports